import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {BodyContainer} from "../../../shared"

const Outer = styled(BodyContainer)`
  background-color: ${greys.lightest};
  border-radius: 0 0 6px 6px;
  border-top: 1px solid rgba(61, 61, 54, 0.25);
`

const Inner = styled.div`
  max-width: 570px;
  margin-left: auto;
  margin-right: auto;
  padding: ${padding.base} ${padding.tiny};
  ${minWidthMedia.desktop`
    padding: ${padding.base};
  `}
`

const Bottom = ({children, className}) => {
  return (
    <Outer className={className}>
      <Inner>
        {children}
      </Inner>
    </Outer>
  )
}

Bottom.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

Bottom.defaultProps = {
  className: null
}

export default Bottom
